import { APPLICATION_REPORTING_STATUS } from '@/helpers/reporting';
import { FR_APPLICATION_STATUSES } from '@/helpers/fundraising';
import { useGetApplicationByFundraisingId } from '@/query/queries/fundraising/useGetApplicationByFundraisingId';

export const useApplicationStatusByFundraisingId =(fundraisingId, params) => {
  const { data: application, refetch, isLoading } = useGetApplicationByFundraisingId(fundraisingId);

  const documentsRequired = !!(
    application && Object.keys(application.reporting.required_documents).length
  );

  let applicationWithoutDocsRequired =
    (application?.status === null || application?.status === FR_APPLICATION_STATUSES.NEW) &&
    !Object.keys(application?.reporting.required_documents).length;

  if (
    application?.status === null &&
    !params?.newFunds &&
    !!params?.selectedRefin?.length &&
    [
      APPLICATION_REPORTING_STATUS.ON_TIME,
      APPLICATION_REPORTING_STATUS.GRACE_OK,
      APPLICATION_REPORTING_STATUS.LATE,
    ].includes(application?.reporting.status)
  ) {
    applicationWithoutDocsRequired = true;
  }

  return { application, refetch, documentsRequired, applicationWithoutDocsRequired, isLoading };
};